import { SubscriptionsScreen } from './SubscriptionsScreen.jsx';

export default {
  path: '/subscriptions',
  element: <SubscriptionsScreen />,
  protected: true,
  permission: null,
  // الاستقبال والمحاسبة يبيعان ويجدّدان، والإدارة تُعرّف الباقات وترى التقرير.
  // لا مفتاح صلاحية جديد — الخادم يفرض نفس القائمة.
  anyPermission: [
    'pricing.view', 'pricing.edit',
    'reception.view', 'reception.create_session', 'reception.issue_card',
    'checkout.view', 'checkout.settle',
    'reports.view'
  ],
  standalone: false,
  sidebar: { label: 'الاشتراكات الشهرية', icon: 'card', group: 'sales', order: 62 }
};
